import {
  SIGNIN,
  AUTHENTICATED,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SHOW_AUTH_MESSAGE,
  HIDE_AUTH_MESSAGE,
  SIGNUP,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNIN_WITH_FACEBOOK,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
  SIGNIN_WITH_EMAIL,
  SIGNIN_WITH_EMAIL_AUTHENTICATED,
  GENERATE_QR,
  SET_QR,
  VERIFY_UNIQUE_KEY,
  USER_VERIFIED,
  SET_TOKEN,
  RESET_USER_VERIFICATION,
  GET_IS_2FA_ENABLED,
  SET_IS_2FA_ENABLED,
  CHANGE_PASSWORD,
  SET_LOADING,
  SET_USER_PROFILE,
  GET_USER_PROFILE,
} from '../constants/Auth';

export const signIn = (user) => {
  return {
    type: SIGNIN,
    payload: user,
  };
};

export const authenticated = (token) => {
  return {
    type: AUTHENTICATED,
    token,
  };
};

export const signOut = () => {
  return {
    type: SIGNOUT,
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  };
};

export const signUp = (user) => {
  return {
    type: SIGNUP,
    payload: user,
  };
};

export const signUpSuccess = (token) => {
  return {
    type: SIGNUP_SUCCESS,
    token,
  };
};

export const signInWithGoogle = () => {
  return {
    type: SIGNIN_WITH_GOOGLE,
  };
};

export const signInWithGoogleAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    token,
  };
};

export const signInWithEmail = (payload) => {
  return {
    type: SIGNIN_WITH_EMAIL,
    payload,
  };
};

export const signInWithEmailAuthenticated = (payload) => {
  return {
    type: SIGNIN_WITH_EMAIL_AUTHENTICATED,
    payload,
  };
};

export const signInWithFacebook = () => {
  return {
    type: SIGNIN_WITH_FACEBOOK,
  };
};

export const signInWithFacebookAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
    token,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message,
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const setLoading = (isLoading) => {
  return {
    type: SET_LOADING,
    isLoading,
  };
};

export const generateQR = () => {
  return {
    type: GENERATE_QR,
  };
};

export const setQR = (qr) => {
  return {
    type: SET_QR,
    qr,
  };
};

export const verifyUniqueKey = (uniqueKey) => {
  return {
    type: VERIFY_UNIQUE_KEY,
    uniqueKey,
  };
};

export const userVerified = () => {
  return {
    type: USER_VERIFIED,
    isVerified: true,
  };
};

export const setToken = () => {
  return {
    type: SET_TOKEN,
  };
};

export const resetUserVerification = () => {
  return {
    type: RESET_USER_VERIFICATION,
  };
};

export const getIs2FAEnabled = () => {
  return {
    type: GET_IS_2FA_ENABLED,
  };
};

export const setIs2FAEnabled = (Is2FAEnabled) => {
  return {
    type: SET_IS_2FA_ENABLED,
    Is2FAEnabled,
  };
};

export const changePassword = (password) => {
  return {
    type: CHANGE_PASSWORD,
    password,
  };
};

export const getUserProfile = (payload) => {
  return {
    type: GET_USER_PROFILE,
    payload,
  };
};

export const setUserProfile = (payload) => {
  return {
    type: SET_USER_PROFILE,
    payload,
  };
};
